import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { MenuToggleStateType } from '@hooks_common/useMenuToggle';

const { persistAtom } = recoilPersist();
export const sideBar = atom<MenuToggleStateType>({
  key: 'sidebar',
  default: {
    openPro: true,
    openCsTool: true,
    openIqfu: true,
    openChat: true,
    openLeaseback: true,
    openDeal: true,
    openJusetsu: true,
    openOthers: true,
    openGrowthTools: true,
  },
  effects_UNSTABLE: [persistAtom],
});
